<template>
    <v-autocomplete
        ref="r_city"
        v-model="reqCity"
        :disabled="!req.filter.hosp || loading.req.province || loading.req.city"
        :clearable="req.filter.hosp"
        color="teal"
        label="City"
        :items="cityItems"
        item-text="city_name"
        item-value="uid"
        return-object
        auto-select-first
        autocomplete="nope"
        :loading="loading.req.province || loading.req.city"
        @change="handleChangeReqCity($event)"
    >
        <template #item="{ item }">
            <v-list-item-content>
                <v-list-item-title>{{ item.city_name }}</v-list-item-title>
                <v-list-item-subtitle>{{ item.city_region }}, {{ item.city_province }}</v-list-item-subtitle>
            </v-list-item-content>
        </template>
    </v-autocomplete>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
    props: ['req', 'member_model', 'loading'],
    data: () => ({
        reqCity: null
    }),
    computed: {
        ...mapGetters(['getReqCities', 'getReqProvinces']),
        cityItems() {
            return (this.getReqCities || []).map(item => ({
                ...item,
                uid: `${item.city_region}${item.city_province}${item.city_name}`
            }))
        }
    },
    watch: {
        getReqCities() {
            this.loading.req.city = false
        },
        'req.city'(newVal) {
            if (!newVal) {
                this.reqCity = null
                return
            }
            this.reqCity = this.cityItems.find(i => i.city_name === newVal) || null
        }
    },
    methods: {
        ...mapActions(['reqHospClin']),
        handleChangeReqCity(item) {
            if (!item) {
                this.req.city = null
                this.req.facility = ''
                this.req.filter.doc = false
                this.req.specField = { sp_name: 'ALL', sp_desc: '' }
                this.req.hospClinDoctor = ''
                this.req.hospClinType = 'H'
                this.req.decking = ''

                this.loading.req.hospital = true
                this.reqHospClin({
                    REGION: this.req.region ? this.req.region : '',
                    PROVINCE: this.req.province ? this.req.province : '',
                    CITY: '',
                    TYPE: '',
                    MEMBN: this.member_model.MEMB_N
                })
                return
            }

            this.req.city = item.city_name
            this.req.province = item.city_province
            this.req.region = item.city_region
            this.req.facility = ''
            this.req.filter.doc = false
            this.req.specField = { sp_name: 'ALL', sp_desc: '' }
            this.req.hospClinDoctor = ''
            this.req.hospClinType = 'H'
            this.req.decking = ''

            this.reqHospClin({
                REGION: item.city_region,
                PROVINCE: item.city_province,
                CITY: item.city_name,
                TYPE: '',
                MEMBN: this.member_model.MEMB_N
            })
        }
    }
}
</script>
